module.exports = __webpack_public_path__ + "img/1585851430346119507.3edf1850.jpg";